import React, { Component } from 'react';
import { graphql, createPaginationContainer } from 'react-relay';
import { Link, NavLink } from 'react-router-dom';
import moment from 'moment';

import { StoreProvider, PaginatedList } from '../../components';
import { OfferList } from '../Offers';

const pageSize = 100;

export class Offers extends Component {
  handleLoadMore = (completion) => {
    this.props.relay.loadMore(pageSize, completion);
  };

  render() {
    const { offers: connection } = this.props.lists;
    const offers = connection.edges.map((e) => e.node);

    return (
      <div className="offers">
        <div className="header">
          <h2>Offers</h2>
          <div className="actions">
            <Link to="/offers/new" className="button">
              New Offer
            </Link>
          </div>
        </div>
        <PaginatedList
          canLoadMore={connection.pageInfo.hasNextPage}
          onLoadMore={this.handleLoadMore}
        >
          <div className="tabs">
            <NavLink to="/offers/tab/active" activeClassName="active">
              Active
            </NavLink>
            <NavLink to="/offers/tab/upcoming" activeClassName="active">
              Upcoming
            </NavLink>
            <NavLink to="/offers/tab/expired" activeClassName="active">
              Expired
            </NavLink>
          </div>
          <OfferList offers={offers} />
        </PaginatedList>
      </div>
    );
  }
}

const OffersContainerQuery = graphql`
  query OffersContainerQuery(
    $first: Int = 100
    $after: String
    $startingAfter: DateTime
    $endingBefore: DateTime
    $active: Boolean = true
  ) {
    lists {
      ...OffersContainer_lists
        @arguments(
          first: $first
          after: $after
          startingAfter: $startingAfter
          endingBefore: $endingBefore
          active: $active
        )
    }
  }
`;

const OffersContainer = createPaginationContainer(
  Offers,
  {
    lists: graphql`
      fragment OffersContainer_lists on Lists
      @argumentDefinitions(
        first: { type: "Int" }
        after: { type: "String" }
        startingAfter: { type: "DateTime" }
        endingBefore: { type: "DateTime" }
        active: { type: "Boolean" }
      ) {
        offers(
          first: $first
          after: $after
          startingAfter: $startingAfter
          endingBefore: $endingBefore
          active: $active
        )
          @connection(
            key: "Offers_offers"
            filters: ["active", "startingAfter", "endingBefore"]
          ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              ...OfferList_offers
            }
          }
        }
      }
    `,
  },
  {
    direction: 'forward',
    getConnectionFromProps: (props) => props.lists.offers,
    getFragmentVariables: (previousVariables, totalCount) => {
      return {
        ...previousVariables,
        first: totalCount,
      };
    },
    getVariables: (props, paginationInfo, fragmentVariables) => {
      const variables = preprocessParams(props.match.params);

      return {
        ...variables,
        after: paginationInfo.cursor,
        first: pageSize,
      };
    },
    query: OffersContainerQuery,
  }
);

const preprocessParams = (params) => {
  const variables = {
    startingAfter: null,
    endingBefore: null,
    active: false,
  };

  switch (params.type) {
    case 'upcoming':
      variables.startingAfter = moment().startOf('hour').toISOString();
      break;
    case 'expired':
      variables.endingBefore = moment().startOf('hour').toISOString();
      break;
    default:
      variables.active = true;
  }

  return variables;
};

export default class OffersList extends Component {
  render() {
    return (
      <StoreProvider
        modern
        container={OffersContainer}
        preprocessParams={preprocessParams}
        query={OffersContainerQuery}
      />
    );
  }
}
